<p-inputSwitch
        [ngModel]="isActive"
        (onChange)="onToggle($event)"
        [pTooltip]="tooltip"
        tooltipPosition="bottom"
        tooltipStyleClass="tooltip-class">
</p-inputSwitch>